/* 

----- Back To Top ----- 
This is the button that appear at the bottom of the page that takes you back to the top of the viewport.
- There is configuration for defining the threshold from the top that the button appears.
- Which side the button appears on is controlled via the SASS.
- THIS MODULE DOESN'T SUPPORT AJAX.
*/

import { AXISDebug } from "../lib/axis-debug";

// Initialise all 
function initialiseAll() {
    // Find all elements.
    let elements = $('[' + expressSelectors()['back-to-top']['initialise'] + ']');
    if (elements) {
        // Loop through all elements.
        elements.each(function() {
            // Grab context.
            let context = $(this);
            // Initialise.
            let init = initialise(context);
        });
    }
}

// Initialise.
function initialise(context) {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Back To Top: Found an instance, attempting to initialise", context);
    }
    // Back to top configuration.
    let triggerDistance = context.attr('[' + expressSelectors()['back-to-top']['trigger-distance'] + ']');
    // Default fallback.
    if (triggerDistance == undefined) {
        triggerDistance = {
            'small': 400,
            'large': 800
        }
    }
    let animationDuration = parseInt(context.attr('[' + expressSelectors()['back-to-top']['animation-duration'] + ']'));
    // Default.
    if (!animationDuration) {
        animationDuration = 500;
    }

    // Add scroll listener.
    $(window).on('scroll',function(event) {
        // Different breakpoints have different trigger thresholds.
        if (currentBreakpoint() <= 2) {
            if ($(window).scrollTop() > triggerDistance['small']) {
                showButton();
            } else {
                hideButton();
            }
        } else if (currentBreakpoint() >= 3) {
            if ($(window).scrollTop() > triggerDistance['large']) {
                showButton();
            } else {
                hideButton();
            }
        }

        // Check if users is at the bottom of the page. 
        if($(window).scrollTop() + $(window).height() == $(document).height()) {
            context.addClass('animated bounce');
            setTimeout(() => {
                context.removeClass('animated bounce');
            }, 1000); 
        }

        // This functionality is purely for mobile devices to make sure the back to top button doesn't overlap sticky elements.
        // Check if button is overlapping another sticky element.
        let stickyElements = $('[' + expressSelectors()['axis-sticky']['initialise'] + ']');
        // Get button position.
        let position = context.offset().top;
        // Suppressing as this is causing the back to top mechanism to be completely hidden if you scroll over another stick element and as we're moving towards more sticky elements on the page this solution is no longer sufficient and will need to be reveiwed until then going to hardcode the css to make sure the back to top button sits above the sticky buttons for manage calls.
        // if (stickyElements) {
        //     stickyElements.each(function() {
        //         // Get context of stick element.
        //         let stickyElementContext = $(this);
        //         // Get its position top.
        //         let stickyPosTop = stickyElementContext.offset().top;
        //         // Get its height to work out the bottom.
        //         let stickyElementHeight = stickyElementContext.outerHeight();
        //         // Get its position bottom.
        //         let stickyPosBottom = (stickyPosTop + stickyElementHeight);
        //         // Find out whether context is overlapping.
        //         let isOverlapping = valueBetween(position, stickyPosTop, stickyPosBottom);
        //         if (currentBreakpoint() <= 2) {
        //             if (isOverlapping) {
        //                 context.parents('.back-top-container').css('bottom', (stickyElementHeight + 10));
        //             }
        //         } else {
        //             context.parents('.back-top-container').css('bottom', '');
        //         }
                
        //     });
        // }
    });

    // Click listener for scrolling back to the top.
    context.on('click', () => {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Back To Top: button clicked attempting to scroll back to top of viewport.", context);
        }
        $('html, body').animate({
            scrollTop: 0
        }, animationDuration);
    });



    // Close timout count.
    let closeTimeout = 0;
    // Used to show the back to top button.
    function showButton() {
        clearTimeout(closeTimeout);
        // Add class.
        context.addClass('active');
        // Remove hide class.
        if (context.hasClass('hide')) {
            context.removeClass('hide');
        }
    }

    // Used to hide the back to top button.
    function hideButton() {
        clearTimeout(closeTimeout);
        if (!context.hasClass('hide')) {
            // Remove active class.
            context.removeClass('active');
            closeTimeout = setTimeout(() => {
                // Setting timeout to allow for the animation to run then add hide class so display:none; is set so the button is not longer clickable.
                context.addClass('hide');
            }, (animationDuration + 500));
        }
    }
}

var backToTop = $.backToTop = {
    initialiseAll: () => {
        return initialiseAll();
    }
}
  
export { backToTop };